import { AlarmClockIcon } from '@hugeicons/react'

import {
  LevelPlayInterstitial,
  LevelPlayInterstitialRestartAction
} from './LevelPlayInterstitial'

/** Tempo esgotado. Servida aos dois domínios. */
export const LevelPlayOutOfTime = ({ onRestart }: { onRestart: () => void }) => (
  <LevelPlayInterstitial
    icon={<AlarmClockIcon size={48} variant="duotone" className="text-danger" />}
    title="Tempo esgotado"
    description="É uma pena, mas seu tempo de resposta acabou!"
    action={<LevelPlayInterstitialRestartAction onRestart={onRestart} />}
  />
)
